<template lang="pug">
  .cashback-grid-container(v-if="gridComponent && gridList.length === 3")
    //- 头部：标题 + 返币订单入口
    CashbackHeader(
      :moduleName="rakeBackModuleInfo.moduleName || '电商购物返奖励金'"
      :mainText="rakeBackModuleInfo.mainText || ''"
      :subText="rakeBackModuleInfo.subText || '返佣订单'"
    )

    //- 模块内容区：上方触发区 + 宫格 + 下方触发区
    .cashback-grid-content
      //- 上方触发区（topTriggerPoint）
      component(
        v-if="topTriggerPoint"
        :is="TRIGGER_COMPONENT_MAP[topTriggerPoint.templateType]"
        :data="topTriggerPoint"
        position="top"
      )

      //- 宫格/瓷片（固定展示）
      component(
        :is="gridComponent"
        :grid-list="gridList"
        @grid-click="handleGridClick"
      )

      //- 下方触发区（bottomTriggerPoint）
      component(
        v-if="bottomTriggerPoint"
        :is="TRIGGER_COMPONENT_MAP[bottomTriggerPoint.templateType]"
        :data="bottomTriggerPoint"
        position="button"
      )
</template>

<script>
import { envManager } from '@hb/generate-income-components';
import config from '@/const/config';
import { adaptChannelData, handleChannelJump } from '../../../utils';
import CashbackHeader from './cashback-header.vue';
import CashbackGridIcon from './cashback-grid-icon.vue';
import CashbackGridTile from './cashback-grid-tile.vue';
import CashbackBannerV2 from './cashback-banner-v2.vue';
import CashbackNotice from './cashback-notice.vue';
import { FULI_MODULE } from '../../../consts';

// banner和订单通知组件映射
const TRIGGER_COMPONENT_MAP = {
  1: 'CashbackBannerV2',
  3: 'CashbackNotice',
  4: 'CashbackBannerV2',
};

const GRID_STYLE = {
  [FULI_MODULE.welfare_takeout_rebate_module]: 'CashbackGridIcon',
  [FULI_MODULE.welfare_cheese_rebate_module]: 'CashbackGridTile',
};

export default {
  name: 'CashbackPurchaseGrid',
  components: {
    CashbackHeader,
    CashbackGridIcon,
    CashbackGridTile,
    CashbackBannerV2,
    CashbackNotice,
  },
  props: {
    rakeBackModuleInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: ['cashbackStyleVersion'],
  data() {
    return {
      TRIGGER_COMPONENT_MAP,
    };
  },
  computed: {
    // 根据实验版本选择宫格样式组件
    gridComponent() {
      const version = this.cashbackStyleVersion();
      return GRID_STYLE[version] || null;
    },
    // 宫格数据（接口 gridList → ECommerceChannelInfo）
    gridList() {
      const rawList = this.rakeBackModuleInfo.gridList || [];
      const cornerMarkList = this.rakeBackModuleInfo.cornerMarkList || [];
      // 建立 gridGuid → 文案角标文本 的映射
      const cornerMarkMap = {};
      cornerMarkList.forEach((mark) => {
        if (mark.resourceType === 4 && mark.gridGuid) {
          cornerMarkMap[mark.gridGuid] = mark.text;
        }
      });
      return rawList.map((raw) => ({
        ...adaptChannelData(raw),
        cashBackV2CornerMarkText: (raw.guid && cornerMarkMap[raw.guid]) || '',
      }));
    },
    // 上方触发区数据
    topTriggerPoint() {
      return this.rakeBackModuleInfo.topTriggerPoint || null;
    },
    // 下方触发区数据
    bottomTriggerPoint() {
      return this.rakeBackModuleInfo.bottomTriggerPoint || null;
    },
  },
  mounted() {
    // 设置 generate-income-components 的请求环境
    envManager.setEnv(config.env);
    this.$emit('loaded');
  },
  methods: {
    // 宫格点击（item 已经是映射后的 ECommerceChannelInfo 格式）
    handleGridClick(item) {
      handleChannelJump(item);
    },
  },
};
</script>

<style lang="less" scoped>
.cashback-grid-container {
  background-color: #fff;
  border-radius: 0.16rem;
  padding: 0.16rem 0.12rem 0.15rem;
  overflow: hidden;
}

.cashback-grid-content {
  display: flex;
  flex-direction: column;
}
</style>
